import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatTimer } from '../../../utils/orderCompleteUpsell';

const OfferCountdown = ({ expiresAt, serverNow, onExpire }) => {
  const { t } = useTranslation();
  const expiryRef = useRef(false);
  const [remainingMs, setRemainingMs] = useState(() => {
    const expiresTime = new Date(expiresAt || 0).getTime();
    const serverTime = new Date(serverNow || Date.now()).getTime();
    return Math.max(expiresTime - serverTime, 0);
  });

  useEffect(() => {
    expiryRef.current = false;
    const expiresTime = new Date(expiresAt || 0).getTime();
    const serverTime = new Date(serverNow || Date.now()).getTime();
    const deadline = Date.now() + Math.max(expiresTime - serverTime, 0);

    const tick = () => {
      const nextRemainingMs = Math.max(deadline - Date.now(), 0);
      setRemainingMs(nextRemainingMs);
      if (nextRemainingMs > 0 || expiryRef.current) return;
      expiryRef.current = true;
      onExpire?.();
    };

    tick();
    const intervalId = window.setInterval(tick, 1000);
    return () => window.clearInterval(intervalId);
  }, [expiresAt, onExpire, serverNow]);

  return (
    <div className="t-flex t-flex-wrap t-items-center t-justify-center t-gap-1.5 t-rounded-xl t-bg-navy t-px-3.5 t-py-2.5 t-text-center t-text-[12.5px] t-font-semibold t-text-white">
      <span>{t('DealBanner_Text')}</span>
      <span className="t-font-mono t-text-sm t-font-extrabold t-tabular-nums t-text-butter">
        {formatTimer(remainingMs)}
      </span>
      {remainingMs <= 0 && <span className="t-text-butter">{t('OrderComplete_TimerExpired')}</span>}
    </div>
  );
};

export default OfferCountdown;
